export class ScriptsHttp {
    /**
     * Get all scripts
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getScripts() {
        try {
            return await window.axios.get(`scripts`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Create a new scripts
     * @param script
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createNewScript(script) {
        try {
            return await window.axios.post(`scripts`, script);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update a scripts
     * @param script
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateScript(script) {
        try {
            return await window.axios.put(`scripts`, script);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Delete a scripts
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async archiveScript(id) {
        try {
            return await window.axios.delete(`scripts/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
